import axios from 'axios'

export default {
  name: 'getAlerts',

  data () {
    return {
      alerts: [],
      isErrorAlerts: false,
      isLoadingAlerts: true
    }
  },

  methods: {
    getProjectAlerts (projectId) {
      axios.get(process.env.VUE_APP_API_ENDPOINT + '/alerts/' + projectId)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.alerts = response.data
            this.isLoadingAlerts = false
          }
        })
        .catch((error) => {
          if (error.response) {
            this.isLoadingAlerts = false
            this.isErrorAlerts = true
            this.errorData = { code: error.response.data.statusCode, message: error.response.data.message, type: error.response.data.error }
          }
        })
    }
  }
}
